import PanResponder from "../vendor/react-native/PanResponder/index.mjs";
var PanResponder_default = PanResponder;
export { PanResponder_default as default };
//# sourceMappingURL=index.mjs.map
